import productService from "../../../../services/ProductService"
import featureService from "../../../../services/FeatureService"
import Notify from "../../../../elements/Notify"
import Dialog from "../../../../elements/Dialog"

export default {
   name: 'FeatureForm',
   data() {
      return {
         product : {
            id  : '',
            name: ''
         },
         feature: {
            id        : '',
            property  : '',
            value     : '',
            status    : true,
            product_id: '',
            created_at: ''
         },
         isEdit  : false,
         loading : false,
         columns: [
            {
               name: 'number',
               label: '#',
               align: 'left',
               style: 'width: 50px'
            },
            {
               name: 'property',
               label: 'Propiedad',
               align: 'left',
               field: 'property',
            },
            {
               name: 'value',
               label: 'Valor',
               align: 'left',
               field: 'value',
            },
            {
               name: 'status',
               label: 'Disponible',
               align: 'center',
               field: 'status',
               style: 'width: 80px'
            },
            {
               name: 'action',
               label: 'Acciones',
               align: 'center',
               style: 'width: 100px'
            },
         ],
         tableData: [],
      }
   },
   beforeRouteEnter(to, from , next) {
      productService.getProductById(to.params.productId)
         .then((snapshot) => {
            let product = snapshot.val()
            if (product != null) {
               next(vm => vm.setProduct(product))
            }
            else {
               next({ name: 'products' })
            }
         })
         .catch(() => {
            Notify.error("No existe el producto.")
            next({ name: 'products' })
         })
   },
   created() {
      this.$store.dispatch('title', 'Editar producto')
   },
   methods: {
      saveFeature() {
         if (this.isEdit) {
            this.updateFeature()
         }
         else {
            this.newFeature()
         }
      },
      editFeature(feature) {
         this.isEdit  = true
         this.feature = {
            id        : feature.id,
            property  : feature.property,
            value     : feature.value,
            status    : feature.status,
            product_id: feature.product_id,
            created_at: feature.created_at
         }
      },
      newFeature() {
         let feature = this.getFeature()
         featureService.storeFeature(feature)
            .then(() => {
               Notify.success("Se registro correctamente.")
               this.resetForm()
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      updateFeature() {
         let feature = this.getFeature()
         featureService.updateFeature(feature)
            .then(() => {
               Notify.success("Se actualizó correctamente.")
               this.resetForm()
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      getFeature() {
         return {
            id        : this.feature.id,
            property  : this.feature.property,
            value     : this.feature.value,
            status    : this.feature.status,
            product_id: this.feature.product_id,
            created_at: this.feature.created_at
         }
      },
      getDataDefaultFeature() {
         return {
            id        : '',
            property  : '',
            value     : '',
            status    : true,
            product_id: this.product.id,
            created_at: ''
         }
      },
      deleteFeature(feature) {
         Dialog.confirm('Eliminar', '¿Esta seguro de querer eliminar este característica? No se podrá recuperar esta información nuca mas.')
            .then(() => {
               this.resetForm()
               featureService.deleteFeature(feature.id, feature.product_id)
                  .then(() => {
                     Notify.success("Se eliminó correctamente.")
                  })
                  .catch((e) => {
                     Notify.error(e)
                  })
            })
            .catch(() => {
               Notify.info("Gracias por no eliminarme.")
            })
      },
      changeStatus(feature) {
         featureService.updateStatus(feature)
            .then(() => {
               Notify.success("Se actualizó el estado de la característica.")
            })
            .catch((e) => {
               Notify.error(e)
            })
      },
      setProduct(product) {
         this.product.id = product.id
         this.product.name = product.name

         this.feature = this.getDataDefaultFeature()

         featureService.getRefByProduct(this.product.id).on('value', snapshot => {
            this.setTableData(snapshot.val())
            this.loading = false
         })
      },
      setTableData(data) {
         this.tableData = []
         for (const key in data) {
            if (data.hasOwnProperty(key)) {
               const element = data[key]
               element.status = element.status == '1'
               this.tableData.push(element)
            }
         }
      },
      resetForm() {
         this.feature = this.getDataDefaultFeature()
         this.isEdit = false
      }
   },
   computed: {
      statusText() {
         return this.feature.status ? 'Disponible' : 'No disponible'
      },
      textButtonSubmit() {
         return this.isEdit ? 'Guardar' : 'Registrar'
      }
   }
}
